"use strict";

module.exports = ['$resource', function ( $resource ) {

    let Presenter = $resource('/presenters/:id',
        {
            id: '@id'
        },
        {
            'save': {method:'POST'},
            'update': {method: 'PATCH'}
        }
    );

    var save = Presenter.save;

    // Required for "easy" .save in controllers
    Presenter.save = function ( ...args ) {

        if( args[0].id ) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return Presenter;
}];
